import * as Types from '../../.cache/__types__/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUserDetailsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUserDetailsQuery = { __typename?: 'Query', user_details?: { __typename?: 'UserDetails', id: string, email?: string | null, individual_stripe_customer_id?: string | null, current_workspace: { __typename?: 'CurrentWorkspace', id: string, name?: string | null, type: Types.WorkspaceType, avatar_url?: string | null, stripe_customer_id?: string | null, tags?: { __typename?: 'WorkspaceTags', disable_email_signatures?: boolean | null } | null, plan: { __typename?: 'WorkspaceProfilePlan', is_trialing: boolean, max_personal_cards: number, name: string, type: Types.WorkspacePlanType }, profile: { __typename?: 'CurrentWorkspaceProfile', id: string, role: Types.WorkspaceRole, given_name?: string | null, family_name?: string | null, avatar_url?: string | null } } } | null };


export const GetUserDetailsDocument = gql`
    query getUserDetails {
  user_details {
    id
    email
    individual_stripe_customer_id
    current_workspace {
      id
      name
      type
      tags {
        disable_email_signatures
      }
      avatar_url
      plan {
        is_trialing
        max_personal_cards
        name
        type
      }
      stripe_customer_id
      profile {
        id
        role
        given_name
        family_name
        avatar_url
      }
    }
  }
}
    `;

/**
 * __useGetUserDetailsQuery__
 *
 * To run a query within a React component, call `useGetUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserDetailsQuery, GetUserDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserDetailsQuery, GetUserDetailsQueryVariables>(GetUserDetailsDocument, options);
      }
export function useGetUserDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserDetailsQuery, GetUserDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserDetailsQuery, GetUserDetailsQueryVariables>(GetUserDetailsDocument, options);
        }
export function useGetUserDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserDetailsQuery, GetUserDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserDetailsQuery, GetUserDetailsQueryVariables>(GetUserDetailsDocument, options);
        }
export type GetUserDetailsQueryHookResult = ReturnType<typeof useGetUserDetailsQuery>;
export type GetUserDetailsLazyQueryHookResult = ReturnType<typeof useGetUserDetailsLazyQuery>;
export type GetUserDetailsSuspenseQueryHookResult = ReturnType<typeof useGetUserDetailsSuspenseQuery>;
export type GetUserDetailsQueryResult = Apollo.QueryResult<GetUserDetailsQuery, GetUserDetailsQueryVariables>;